import { Navigate, useLocation } from "react-router-dom";
import { useNatlCommitteeManagementGate } from "./useNatlCommitteeManagementEnabled";
import LegacyCommitteesRedirect from "./_LegacyCommitteesRedirect";

export function CommitteesLegacyTermRedirect() {
  const { enabled, flagsLoaded } = useNatlCommitteeManagementGate();
  const location = useLocation();

  if (!flagsLoaded) {
    return null;
  }

  if (!enabled) {
    return <LegacyCommitteesRedirect />;
  }

  return (
    <Navigate
      to={{
        pathname: location.pathname.replace(
          "/people/membership-services/committees",
          "/people/membership-services/legacy-committees"
        ),
        search: location.search,
        hash: location.hash
      }}
      replace
    />
  );
}
